import {
  DataGrid,
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import React, { useState, useMemo, useRef } from "react";
import "./BillingGrid.scss";

import { Box } from "@mui/system";
import {
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import moment from "moment";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import graphqlRequest from "../../../requestMethod";
import eventHelpers from "../../../Helpers/Event";
import JSZip from "jszip";
import BillingActionCell from "./BillingActionCell";
import { Tooltip } from "@mui/material";
import TransactionHistory from "./TransactionHistory";
import { pushEvent } from "../../../utils/clevertap";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";

const BillingGrid = ({ data }) => {
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("");
  const [branchFilter, setBranchFilter] = useState("");
  const [monthFilter, setMonthFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const searchInputRef = useRef(null);

  // ✅ Extract unique values for filters
  const uniqueBranches = [
    ...new Set(
      data.map((d) => d?.branch?.jobLocation?.branchName).filter(Boolean)
    ),
  ];
  const uniqueMonths = [
    ...new Set(
      data
        .map((d) => {
          if (!d.billingDate) return "";
          const dateObj = new Date(Number(d.billingDate));
          return isNaN(dateObj)
            ? ""
            : dateObj.toLocaleString("en-US", { month: "long" });
        })
        .filter(Boolean)
    ),
  ];

  // ✅ Apply filters
  const filteredData = useMemo(() => {
    return data.filter((row) => {
      const matchStatus =
        !paymentStatusFilter || row.status === paymentStatusFilter;

      const branchName = row?.branch?.jobLocation?.branchName;
      const matchBranch = !branchFilter || branchName === branchFilter;

      const dateObj = row.billingDate
        ? new Date(Number(row.billingDate))
        : null;
      const monthName = dateObj
        ? dateObj.toLocaleString("en-US", { month: "long" })
        : "";
      const matchMonth = !monthFilter || monthName === monthFilter;

      // Search functionality
      const matchSearch = !searchQuery || 
        (row.billNumber && row.billNumber.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (branchName && branchName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (row.status && row.status.toLowerCase().includes(searchQuery.toLowerCase()));

      return matchStatus && matchBranch && matchMonth && matchSearch;
    });
  }, [data, paymentStatusFilter, branchFilter, monthFilter, searchQuery]);

  var rowArray = [];
  var i = 1;
  // console.log("data", data);
  // if (data.length > 0) {
  //   rowArray = [];

  //   let RowObj = {
  //     id: "",
  //     jobID: "",
  //     billNumber: "",
  //     hospitalBranch: "",
  //     department: "",
  //     jobStartDate: "",
  //     numOfDays: "",
  //     amount: "",
  //     url: "",
  //     url2: "",
  //     uniqueIdentifier: "",
  //   };
  //   data.map((obj) => {
  //     RowObj.billNumber = obj?.billNumber;
  //     RowObj.amount = obj?.amount;
  //     RowObj.hospitalBranch = obj?.branch?.jobLocation?.branchName;
  //     RowObj.url = obj?.url;
  //     RowObj.url2 = obj?.url2;
  //     if (obj?.userInvoices.length > 0) {
  //       obj?.userInvoices?.map((ele) => {
  //         RowObj.id = i;
  //         RowObj.jobID = ele?.jobId;
  //         RowObj.uniqueIdentifier = ele?.jobId + " " + obj?.billNumber;
  //         RowObj.department = ele?.departmentName;
  //         RowObj.numOfDays = ele?.numberOfDays;
  //         if (ele?.consequtiveTime?.start?.ts) {
  //           let newDate = moment(parseInt(ele?.consequtiveTime?.start?.ts)).add(
  //             5.5,
  //             "hours"
  //           )?._d;
  //           RowObj.jobStartDate = moment(newDate).format("L");
  //           i++;
  //         } else if (ele?.nonConsequtiveTime?.start?.ts) {
  //           let newDate = moment(
  //             parseInt(ele?.nonConsequtiveTime?.start?.ts)
  //           ).add(5.5, "hours")?._d;
  //           RowObj.jobStartDate = moment(newDate).format("L");
  //           i++;
  //         }

  //         rowArray.push({ ...RowObj });
  //       });
  //     }
  //   });
  // }

  // console.log("rowArray", rowArray.length);

  // var arrayUniqueByKey = [];
  // if (rowArray) {
  //   const key = "uniqueIdentifier";

  //   arrayUniqueByKey = [
  //     ...new Map(rowArray.map((item) => [item[key], item])).values(),
  //   ];
  // }

  const fetchUserId = async () => {
    let data = localStorage.getItem("auth");
    let token = JSON.parse(data)?.accessToken;
    try {
      const query = `
    query {
      withAuth(token: "${token}"){
       userDetails{
        id,
        name {
          salutation
          first
          middle
          last
          full
        },
        emails {
          isPrimary
          isVerified
          address
        },
        phoneNumbers{
          number
        }
      }
      }
    }
      `;
      const response = await graphqlRequest(query);
      // console.log("175-->",response)
      return response;
    } catch (error) {
      console.error("Error sending GraphQL request:", error);
    }
  };

  const trackBillingDownload = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;
    // console.log("User>>>>>", userPhone)

    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      // Moengage.add_mobile("+12399999999");
      window.Moengage.add_mobile(userPhone);
      //set event data
      window.Moengage.track_event(
        eventHelpers.BILLING_DOWLD
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  const trackBillingExport = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      //set event data
      window.Moengage.track_event(
        eventHelpers.BILLING_EXPORT
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  //COLUMN

  const columns = [
    // {
    //   field: "jobID",
    //   headerClassName: "billing--header",
    //   headerName: `JOB ID`,

    //   // valueGetter: getID,
    //   flex: 1,
    // },
    {
      field: "billNumber",
      headerName: `Bill Number`,
      headerClassName: "billing--header",
      renderCell: (cellValues) => {
        // console.log(">>>", cellValues);
        const billNumber = cellValues?.row?.billNumber;
        return billNumber;
      },

      // valueGetter: getID,
      flex: 1,
    },
    {
      field: "hospitalBranch",
      headerClassName: "billing--header",
      headerName: `Hospital Branch`,
      renderCell: (cellValues) => {
        const branchName = cellValues?.row?.branch?.jobLocation?.branchName;
        return (
          <Tooltip title={branchName} arrow>
            {branchName}
          </Tooltip>
        );
        // return branchName;
      },

      valueGetter: (params) =>
        params.row?.branch?.jobLocation?.branchName || "",
      flex: 1,
    },
    // {
    //   field: "department",
    //   headerClassName: "billing--header",
    //   headerName: `Department`,

    //   // valueGetter: getID,
    //   flex: 1,
    // },
    // {
    //   field: "jobStartDate",
    //   headerClassName: "billing--header",
    //   headerName: `Job Start Date`,

    //   // valueGetter: getID,
    //   flex: 1,
    // },
    {
      field: "months",
      headerClassName: "billing--header",
      headerName: `Month`,
      renderCell: (cellValues) => {
        const billingDate = cellValues?.row?.billingDate;
        if (!billingDate) return "";

        const dateObj = new Date(Number(billingDate));
        if (isNaN(dateObj)) return "";
        const monthName = dateObj.toLocaleString("en-US", { month: "long" });
        return monthName;
      },
      valueGetter: (params) => {
        const billingDate = params?.row?.billingDate;
        if (!billingDate) return "";

        const dateObj = new Date(Number(billingDate));
        if (isNaN(dateObj)) return "";
        const monthName = dateObj.toLocaleString("en-US", { month: "long" });
        return monthName;
      },
      flex: 0.5,
    },
    {
      field: "numOfDays",
      headerClassName: "billing--header",
      headerName: `Total Shifts`,
      renderCell: (cellValues) => {
        const numOfDays = cellValues?.row?.numberOfDays;
        return numOfDays;
      },
      valueGetter: (params) => params.row?.numberOfDays || "",
      flex: 0.6,
    },

    {
      field: "amountDue",
      headerClassName: "billing--header",
      headerName: `Amount Due`,
      renderCell: (cellValues) => {
        const numOfDays = cellValues?.row?.amount;
        // return numOfDays;
        if (numOfDays !== undefined && numOfDays !== null) {
          return `₹${Number(numOfDays).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;

        }

        return "₹0";
      },
      valueGetter: (params) => {
        const numOfDays = params?.row?.amount;
        if (numOfDays !== undefined && numOfDays !== null) {
          return `₹${Number(numOfDays).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;

        }

        return "₹0";

      },

      flex: 1,
    },
    {
      field: "amountPaid",
      headerClassName: "billing--header",
      headerName: `Amount Paid`,
      renderCell: (cellValues) => {
        const amountPaid = cellValues?.row?.cashfreeAmountReceived;
        const offLinePayment =
          cellValues?.row?.offlineBillDetails?.amountReceivedAgainstBill;
        console.log("offLinePayment", offLinePayment);
        // return amountPaid ? amountPaid : offLinePayment ? offLinePayment : 0;
        const paidAmount = amountPaid ? amountPaid : offLinePayment ? offLinePayment : 0;

          if (paidAmount !== undefined && paidAmount !== null) {
            return `₹${Number(paidAmount).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`;
          }

          return "₹0";
      },
      valueGetter: (params) => {
        const amountPaid = params?.row?.cashfreeAmountReceived;
        const offLinePayment =
          params?.row?.offlineBillDetails?.amountReceivedAgainstBill;
        // return amountPaid ? amountPaid : offLinePayment ? offLinePayment : 0;
        const paidAmount = amountPaid
          ? amountPaid
          : offLinePayment
          ? offLinePayment
          : 0;

        if (paidAmount !== undefined && paidAmount !== null) {
          return `₹${Number(paidAmount).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }

        return "₹0";
      },

      flex: 1,
    },
    {
      field: "tdsDeduction",
      headerClassName: "billing--header",
      headerName: `TDS Deduction`,
      renderCell: (cellValues) => {
        const totalDeduction =
          parseFloat(cellValues?.row?.tdsBillOfSupplyDeduction) +
          parseFloat(cellValues?.row?.tdsTaxInvoiceDeduction);
        const offLineTdsDeduction =
          cellValues?.row?.offlineBillDetails?.TDSAmount;
        // return totalDeduction
        //   ? totalDeduction
        //   : offLineTdsDeduction
        //   ? offLineTdsDeduction
        //   : 0;

        const tdsAmount = totalDeduction
          ? totalDeduction
          : offLineTdsDeduction
          ? offLineTdsDeduction
          : 0;

        if (tdsAmount !== undefined && tdsAmount !== null) {
          return `₹${Number(tdsAmount).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }

        return "₹0";
      },
      valueGetter: (params) => {
        const totalDeduction =
          parseFloat(params?.row?.tdsBillOfSupplyDeduction) +
          parseFloat(params?.row?.tdsTaxInvoiceDeduction);
        const offLineTdsDeduction = params?.row?.offlineBillDetails?.TDSAmount;
        // return totalDeduction
        //   ? totalDeduction
        //   : offLineTdsDeduction
        //   ? offLineTdsDeduction
        //   : 0;
        const tdsAmount = totalDeduction
          ? totalDeduction
          : offLineTdsDeduction
          ? offLineTdsDeduction
          : 0;

        if (tdsAmount !== undefined && tdsAmount !== null) {
          return `₹${Number(tdsAmount).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }

        return "₹0";
      },

      flex: 1,
    },
    {
      field: "amountPending",
      headerClassName: "billing--header",
      headerName: `Amount Pending`,
      renderCell: (cellValues) => {
        const amount = cellValues?.row?.amount;

        if (parseFloat(cellValues?.row?.cashfreeAmountReceived) > 0) {
          const totalDiffAmount =
            parseFloat(cellValues?.row?.cashfreeAmountReceived || 0) +
            parseFloat(cellValues?.row?.tdsBillOfSupplyDeduction || 0) +
            parseFloat(cellValues?.row?.tdsTaxInvoiceDeduction || 0);
          // console.log("totalDiffAmount",totalDiffAmount)
          const amountPending = amount - totalDiffAmount;
          // return amountPending;
          if (amountPending !== undefined && amountPending !== null) {
            return `₹${Number(amountPending).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`;
          }

         
        } else {
          const totalOfflinePayment =
            parseFloat(
              cellValues?.row?.offlineBillDetails?.amountReceivedAgainstBill ||
                0
            ) + parseFloat(cellValues?.row?.offlineBillDetails?.TDSAmount || 0);
          // console.log("totalOfflinePayment", totalOfflinePayment);
          const amountPendingOffline = amount - totalOfflinePayment;
          // console.log("amountPendingOffline", amountPendingOffline);
          // return amountPendingOffline;
           if (
             amountPendingOffline !== undefined &&
             amountPendingOffline !== null
           ) {
             return `₹${Number(amountPendingOffline).toLocaleString("en-IN", {
               minimumFractionDigits: 2,
               maximumFractionDigits: 2,
             })}`;
           }
        }

        // return amountPending ? amountPending : amountPendingOffline ? amountPendingOffline : 0;
      },
      valueGetter: (params) => {
        const amount = params?.row?.amount;
         if (parseFloat(params?.row?.cashfreeAmountReceived) > 0) {
           const totalDiffAmount =
             parseFloat(params?.row?.cashfreeAmountReceived || 0) +
             parseFloat(params?.row?.tdsBillOfSupplyDeduction || 0) +
             parseFloat(params?.row?.tdsTaxInvoiceDeduction || 0);
           // console.log("totalDiffAmount",totalDiffAmount)
           const amountPending = amount - totalDiffAmount;
           // return amountPending;
           if (amountPending !== undefined && amountPending !== null) {
             return `₹${Number(amountPending).toLocaleString("en-IN", {
               minimumFractionDigits: 2,
               maximumFractionDigits: 2,
             })}`;
           }
         } else {
           const totalOfflinePayment =
             parseFloat(
               params?.row?.offlineBillDetails?.amountReceivedAgainstBill || 0
             ) + parseFloat(params?.row?.offlineBillDetails?.TDSAmount || 0);
           // console.log("totalOfflinePayment", totalOfflinePayment);
           const amountPendingOffline = amount - totalOfflinePayment;
           // console.log("amountPendingOffline", amountPendingOffline);
           // return amountPendingOffline;
           if (
             amountPendingOffline !== undefined &&
             amountPendingOffline !== null
           ) {
             return `₹${Number(amountPendingOffline).toLocaleString("en-IN", {
               minimumFractionDigits: 2,
               maximumFractionDigits: 2,
             })}`;
           }
         }
      },
      flex: 1,
    },

    {
      field: "paymentDueDate",
      headerClassName: "billing--header",
      headerName: `Payment Due Date`,
      renderCell: (cellValues) => {
        const paymentDuePeriodDays =
          cellValues?.row?.branch?.billingInfo?.paymentDuePeriodDays;
        const billingDate = cellValues?.row?.billingDate;

        const dueDate = moment(Number(billingDate))
          .subtract(5.5, "hours")
          .add(parseInt(paymentDuePeriodDays), "days")
          .format("DD/MM/YYYY");

        //  console.log(
        //    "Billing Date:",
        //    moment(Number(billingDate)).subtract(5.5, "hours").format("DD/MM/YYYY")
        //  );
        //  console.log("Due Date:", dueDate);

        return dueDate;
      },
      valueGetter: (params) => {
        const paymentDuePeriodDays =
          params?.row?.branch?.billingInfo?.paymentDuePeriodDays;
        const billingDate = params?.row?.billingDate;

        const dueDate = moment(Number(billingDate))
          .subtract(5.5, "hours")
          .add(parseInt(paymentDuePeriodDays), "days")
          .format("DD/MM/YYYY");
        return dueDate;
      },
      flex: 1,
    },
    {
      field: "paymentStatus",
      headerClassName: "billing--header",
      headerName: `Payment Status`,
      renderCell: (cellValues) => {
        const status = cellValues?.row?.status;
        if (status === "PAID") {
          return "Paid";
        } else if (status === "PARTIAL_PAID") {
          return "Partially Paid";
        } else if (status === "UNPAID") {
          return "Pending Payment";
        } else if (status === "PAYMENT_IN_REVIEW") {
          return "Payment in Review";
        } else {
          return "NA";
        }
        // return numOfDays;
      },
      valueGetter: (params) => {
        const status = params?.row?.status;
        if (status === "PAID") {
          return "Paid";
        } else if (status === "PARTIAL_PAID") {
          return "Partially Paid";
        } else if (status === "UNPAID") {
          return "Pending Payment";
        } else if (status === "PAYMENT_IN_REVIEW") {
          return "Payment in Review";
        } else {
          return "NA";
        }
      },
      flex: 1,
    },
    // {
    //   field: "paymentType",
    //   headerClassName: "billing--header",
    //   headerName: `Payment Type`,
    //   renderCell: (cellValues) => {
    //     const status = cellValues?.row?.paymentMode;
    //     if (status === "partial_payment") {
    //       return "Partial Payment";
    //     } else if (status === "full_payment") {
    //       return "Full Payment";
    //     } else {
    //       return "NA";
    //     }
    //     // return numOfDays;
    //   },
    //   // valueGetter: getID,
    //   flex: 1,
    // },

    // {
    //   field: "amount",
    //   headerClassName: "billing--header",
    //   headerName: `Amount`,
    //   renderCell: (cellValues) => {
    //     const amount = cellValues?.row?.amount;
    //     return amount;
    //   },
    //   // valueGetter: getID,
    //   flex: 1,
    // },
    {
      field: "export",
      headerClassName: "billing--header",
      headerName: `Export`,
      renderCell: (cellValues) => {
        const downloadBothPdf = async () => {
          pushEvent("Web_Billing_Download", {
            page: "Billing",
            section: "Jobs",
            billDetails: cellValues?.row,
          });
          // console.log(">>>", cellValues?.row?.billNumber)
          const lastPart = cellValues?.row?.billNumber.split("/").pop();
          if (cellValues?.row) {
            const zip = new JSZip();

            const fetchAndAddToZip = async (url, fileName) => {
              if (url) {
                const content = await fetch(url).then((response) =>
                  response.blob()
                );
                zip.file(fileName, content);
              }
            };

            await fetchAndAddToZip(cellValues.row.url, `D${lastPart}.pdf`);
            await fetchAndAddToZip(cellValues.row.url2, `${lastPart}.pdf`);

            zip.generateAsync({ type: "blob" }).then((blob) => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = "files.zip";
              link.click();
            });
          } else {
            console.error("URLs are not available");
          }

          // if (cellValues?.row) {
          //   const zip = new JSZip();
          //   const pdf1Content = await fetch(cellValues.row.url).then((response) => response.blob());
          //   const pdf2Content = await fetch(cellValues.row.url2).then((response) => response.blob());

          //   zip.file("file1.pdf",pdf1Content);
          //   zip.file("file2.pdf",pdf2Content);

          //   zip.generateAsync({ type: 'blob' }).then((blob) => {
          //     const link = document.createElement('a');
          //     link.href = URL.createObjectURL(blob);
          //     link.download = 'files.zip';
          //     link.click();
          //   });
          // } else {
          //   console.error('URLs are not available');
          // }
        };

        return (
          <>
            <Tooltip title="Download">
              <a
                href="#"
                onClick={() => {
                  downloadBothPdf();
                  trackBillingDownload();
                }}
              >
                <DownloadIcon
                  sx={{ color: "rgba(0, 70, 138, 1)", cursor: "pointer" }}
                />
              </a>
            </Tooltip>
          </>
        );
      },

      // valueGetter: getID,
      flex: 0.5,
    },

    {
      field: "action",
      headerClassName: "billing--header",
      headerName: `Action`,
      renderCell: (cellValues) => (
        // <BillingActionCell rowData={cellValues.row} />
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BillingActionCell rowData={cellValues.row} />
        </Box>
      ),
      align: "center", // ✅ cell content center
      headerAlign: "center",
      flex: 1,
    },

    {
      field: "lastTransaction",
      headerClassName: "billing--header",
      headerName: `View Transaction Details`,
      renderCell: (cellValues) => {
        // const lastTransaction = cellValues?.row?.lastTransaction;
        // console.log("lastTransaction", lastTransaction);
        // let finalTransactionData = "";
        // let color = "inherit";
        // if (lastTransaction === "FAILED") {
        //   color = "#D32F2F";
        //   finalTransactionData = "Failed";
        // } else if (
        //   lastTransaction === "captured" ||
        //   lastTransaction === "SUCCESS"
        // ) {
        //   color = "#2E7D32";
        //   finalTransactionData = "Success";
        // } else if (lastTransaction === "USER_DROPPED") {
        //   // color = "#FFC107";
        //   color = "#FFB300";
        //   finalTransactionData = "Incomplete";
        // }

        // return (
        //   <div
        //     style={{
        //       display: "flex",
        //       justifyContent: "center",
        //       alignItems: "center",
        //       width: "100%",
        //       height: "100%",
        //     }}
        //   >
        //     <span style={{ color, fontWeight: 600 }}>
        //       {finalTransactionData ? finalTransactionData : "-"}
        //     </span>
        //   </div>
        // );

        const transactionsData = [
          {
            status: "SUCCESS",
            timestamp: "2025-09-15T10:30:00Z",
            paymentMode: "fully paid",
          },
          {
            status: "FAILED",
            timestamp: "2025-09-15T10:25:00Z",
            paymentMode: "partially paid",
          },
          {
            status: "DROPPED",
            timestamp: "2025-09-15T10:22:00Z",
            paymentMode: "partially paid",
          },
          {
            status: "FAILED",
            timestamp: "2025-09-15T10:20:00Z",
            paymentMode: "partially paid",
          },
          {
            status: "CREATED",
            timestamp: "2025-09-15T09:20:00Z",
            paymentMode: "partially paid",
          },
        ];

        const billNumber = cellValues?.row?.billNumber;
        return (
          <TransactionHistory
            billNumber={billNumber}
            billData={cellValues?.row}
          />
        );
      },

      flex: 1,
    },

    {
      field: "url",
      headerClassName: "billing--header",
      headerName: `URL`,
      renderCell: (cellValues) => {
        let url = cellValues?.row?.url;
        let url2 = cellValues?.row?.url2;
        // return {url,url2};
        return (
          <div>
            <p>URL 1: {url}</p>
            <p>URL 2: {url2}</p>
          </div>
        );
      },
      // valueGetter: getID,
      flex: 5,
    },
  ];

  const rows = [
    {
      id: "",
      billNumber: "",
      hospitalBranch: "",
      department: "",
      jobStartDate: "",
      numOfDays: "",
      amount: "",
      action: "",
    },
  ];

  const rowHeight = 52; // default DataGrid row height
  const headerHeight = 56; // approx header height
  const footerHeight = 56; // approx footer (pagination) height

  // function CustomToolbar() {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "space-between",
  //         padding: "0.5rem",
  //       }}
  //     >
  //       {/* left Side - Export Button */}
  //       <Tooltip title="Export">
  //         <IconButton
  //           onClick={handleBulkExport}
  //           sx={{
  //             backgroundColor: 'white',
  //             border: '1px solid #f5f5f5',
  //             borderRadius: '8px',
  //             padding: '8px',
  //             boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  //             '&:hover': {
  //               backgroundColor: '#f8f9ff',
  //               borderColor: '#2563eb',
  //               boxShadow: '0 2px 4px rgba(37, 99, 235, 0.1)',
  //             },
  //           }}
  //         >
  //           <DownloadIcon sx={{ color: "rgba(0, 70, 138, 1)" }} />
  //         </IconButton>
  //       </Tooltip>
  //       {/* Right Side - Quick Search */}
  //       <GridToolbarQuickFilter debounceMs={500} />
  //     </div>
  //   );
  // }

  const handleBulkExport = () => {
    pushEvent("Web_Billing_Bulk_Export", {
      page: "Billing",
      section: "Jobs",
    });
    
    // Export all filtered data
    const headers = [
      "Bill Number",
      "Hospital Branch", 
      "Month",
      "Total Shifts",
      "Amount Due",
      "Amount Paid",
      "TDS Deduction",
      "Amount Pending",
      "Payment Due Date",
      "Payment Status"
    ];
    
    const csvContent = [
      headers.join(','),
      ...filteredData.map(row => [
        row.billNumber || '',
        row?.branch?.jobLocation?.branchName || '',
        row.billingDate ? new Date(Number(row.billingDate)).toLocaleString("en-US", { month: "long" }) : '',
        row.numberOfDays || '',
        row.amount || '',
        row.cashfreeAmountReceived || row?.offlineBillDetails?.amountReceivedAgainstBill || '',
        (parseFloat(row?.tdsBillOfSupplyDeduction || 0) + parseFloat(row?.tdsTaxInvoiceDeduction || 0) + parseFloat(row?.offlineBillDetails?.TDSAmount || 0)) || '',
        // Calculate amount pending
        (() => {
          const amount = parseFloat(row.amount || 0);
          if (parseFloat(row.cashfreeAmountReceived || 0) > 0) {
            const totalDiffAmount = parseFloat(row.cashfreeAmountReceived || 0) + parseFloat(row.tdsBillOfSupplyDeduction || 0) + parseFloat(row.tdsTaxInvoiceDeduction || 0);
            return amount - totalDiffAmount;
          } else {
            const totalOfflinePayment = parseFloat(row?.offlineBillDetails?.amountReceivedAgainstBill || 0) + parseFloat(row?.offlineBillDetails?.TDSAmount || 0);
            return amount - totalOfflinePayment;
          }
        })(),
        // Payment due date
        (() => {
          const paymentDuePeriodDays = row?.branch?.billingInfo?.paymentDuePeriodDays;
          const billingDate = row.billingDate;
          if (paymentDuePeriodDays && billingDate) {
            return moment(Number(billingDate)).subtract(5.5, "hours").add(parseInt(paymentDuePeriodDays), "days").format("DD/MM/YYYY");
          }
          return '';
        })(),
        // Payment status
        (() => {
          const status = row.status;
          if (status === "PAID") return "Paid";
          if (status === "PARTIAL_PAID") return "Partially Paid";
          if (status === "UNPAID") return "Pending Payment";
          if (status === "PAYMENT_IN_REVIEW") return "Payment in Review";
          return "NA";
        })()
      ].map(field => `"${field}"`).join(',')
    )
  ].join('\n');
    
    // Create and download CSV file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'billing-data.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ✅ Custom Toolbar with filters
  function CustomToolbar() {
    const handleSearchChange = (e) => {
      setSearchQuery(e.target.value);
      // Ensure input maintains focus after state change
      setTimeout(() => {
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }, 0);
    };

    const handleContainerClick = () => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    };
    const handleExportClick = () => {
      pushEvent("Web_Billing_Bulk_Export", {
        page: "Billing",
        section: "Jobs",
      });
    };

    return (
      <div className="billing-toolbar">
        {/* Quick Search */}
        {/* <GridToolbarQuickFilter debounceMs={500} /> */}

        {/* Filters */}
        <div className="filters-container">
          {/* Payment Status */}
          <div className={`filter-dropdown ${paymentStatusFilter ? 'has-value' : ''}`}>
            <select
              value={paymentStatusFilter}
              onChange={(e) => setPaymentStatusFilter(e.target.value)}
              className="filter-select"
            >
              <option value="">Payment Status</option>
              <option value="PAID">Paid</option>
              <option value="PARTIAL_PAID">Partially Paid</option>
              <option value="UNPAID">Pending Payment</option>
            </select>
          </div>

          {/* Branch */}
          <div className={`filter-dropdown ${branchFilter ? 'has-value' : ''}`}>
            <select
              value={branchFilter}
              onChange={(e) => setBranchFilter(e.target.value)}
              className="filter-select"
            >
              <option value="">Branch</option>
              {uniqueBranches.map((branch, idx) => (
                <option key={idx} value={branch}>
                  {branch}
                </option>
              ))}
            </select>
          </div>

          {/* Month */}
          <div className={`filter-dropdown ${monthFilter ? 'has-value' : ''}`}>
            <select
              value={monthFilter}
              onChange={(e) => setMonthFilter(e.target.value)}
              className="filter-select"
            >
              <option value="">Month</option>
              {uniqueMonths.map((month, idx) => (
                <option key={idx} value={month}>
                  {month}
                </option>
              ))}
            </select>
          </div>
              <label 
          className={`global-search-container ${searchQuery ? 'has-text' : ''}`}
          onClick={handleContainerClick}
        >
          <div>
            <SearchIcon />
          </div>
          <input
            ref={searchInputRef}
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          />
        </label>

          {/* Reset Button */}
          <div
            className="reset-button"
            onClick={() => {
              setPaymentStatusFilter("");
              setBranchFilter("");
              setMonthFilter("");
              setSearchQuery("");
            }}
            title="Reset Filters"
          >
            <RestartAltIcon />
          </div>
          
          {/* Export Button */}
          <Tooltip title="Export">
            <IconButton
              onClick={handleBulkExport}
              sx={{
                backgroundColor: 'white',
                border: '1px solid #f5f5f5',
                borderRadius: '8px',
                padding: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                '&:hover': {
                  backgroundColor: '#f8f9ff',
                  borderColor: '#2563eb',
                  boxShadow: '0 2px 4px rgba(37, 99, 235, 0.1)',
                },
              }}
            >
              <DownloadIcon sx={{ color: "rgba(0, 70, 138, 1)" }} />
            </IconButton>
          </Tooltip>
      
        </div>
      </div>
    );
  }

  return (
    <Box
      sx={{
        "& .billing--header": {
          backgroundColor: "#2D5FA1",
          color: "white",
          fontWeight: "800",
        },
      }}
    >
      <CustomToolbar />
      <DataGrid
        getRowId={(row) => row.id}
        columns={columns}
        components={{
          NoRowsOverlay: () => (
              <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: { xs: 'flex-start', sm: 'center' },
                                        justifyContent: 'center',
                                        height: '100%',
                                        width: '100%',
                                        textAlign: { xs: 'left', sm: 'center' },
                                        pl: { xs: 8, sm: 0 },
                                      }}
                                    >
                                      <WorkOutlineIcon sx={{ fontSize: { xs: 40, sm: 60 }, color: 'primary.main', mb: 2, ml: { xs: 9, sm: 0 } }} />
                                      <Typography variant="h6" component="p" gutterBottom sx={{ ml: { xs: 14, sm: 0 } }}>
                                      No Billing Records Found
                                      </Typography>
                                       <Typography 
                                                                  variant="body2" 
                                                                  color="text.secondary" 
                                                                  sx={{ 
                                                                    my: 3,
                                                                    fontSize: { xs: '12px', sm: '14px' },
                                                                    lineHeight: { xs: '1.3', sm: '1.5' },
                                                                    maxWidth: { xs: '200px', sm: 'none' },
                                                                    wordBreak: 'break-word',
                                                                    textAlign:'center'
                                                                  }}
                                                                > There are currently no billing records or invoices to display.
                                      </Typography>
                                    </Box>
          ),
        }}
        // componentsProps={{
        //   toolbar: {
        //     showQuickFilter: true,
        //     quickFilterProps: { debounceMs: 500 },
        //   },
        // }}
        // rows={data.length > 0 ? data : []}
        rows={filteredData}
        pagination
        // pageSize={10}
        style={{ margin: 0, marginTop: "1rem" }}
        initialState={{
          columns: {
            columnVisibilityModel: {
              url: false,
              url2: false,
            },
          },
          pagination: {
            paginationModel: { pageSize: 10, page: 0 },
          },
        }}
        pageSizeOptions={[10, 25, 50, 100]}
        disableColumnMenu={true}
        sx={{
          backgroundColor: "#ffffff",
          color: "#333333",
          height: `${rowHeight * 10 + headerHeight + footerHeight}px`, 
          margin: "1rem",
          border: "1px solid #e0e0e0",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#2D5FA1",
            color: "white",
            fontSize: "14px",
            fontWeight: "600",
            borderBottom: "none",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
          },
          
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#2D5FA1",
            color: "white",
            fontSize: "14px",
            fontWeight: "600",
          },
          
          "& .MuiDataGrid-columnHeaderTitle": {
            color: "white",
            fontWeight: "600",
          },
          
          "& .MuiDataGrid-sortIcon": {
            color: "white",
          },
          
          "& .MuiDataGrid-menuIconButton": {
            color: "white",
          },
          
          "& .MuiDataGrid-cell": {
            padding: "12px 16px",
            borderBottom: "1px solid #f0f0f0",
            fontSize: "14px",
            color: "#333333",
            "&:hover": {
              backgroundColor: "#f8f9fa",
            },
          },
          
          "& .MuiDataGrid-row": {
            "&:nth-of-type(even)": {
              backgroundColor: "#fafafa",
            },
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          },
          
          "& .MuiDataGrid-footerContainer": {
            // backgroundColor: "#f8f9fa",
            borderBottomLeftRadius: "12px",
            borderBottomRightRadius: "12px",
            justifyContent: "flex-end",
          },
          
          "& .MuiDataGrid-paginator": {
            color: "#666666",
            border: "none",
          },
          
          "& .MuiTablePagination-root": {
            color: "#666666",
            border: "none",
          },
          
          "& .MuiDataGrid-selectedRowCount": {
            display: "none",
          },
          
          "& .MuiDataGrid-withBorderColor": {
            // borderColor: "#e0e0e0",
            border: "none",
          },
        }}
      />
    </Box>
  );
};

export default BillingGrid;
